import { BreakDaysType } from '@havenengineering/module-shared-owners-library/dist/enums/breakDaysType';
export const DisplayDaysTypeMapping = {
    [BreakDaysType.MIDWEEK]: 'Midweek',
    [BreakDaysType.WEEKEND]: 'Weekend',
};
export const getDisplayDaysType = (daysType) => {
    return DisplayDaysTypeMapping[daysType];
};
